// @ts-nocheck
import * as Klaro from 'klaro/dist/klaro-no-translations-no-css'
import de from './klaro-translations/de.yml'
import en from './klaro-translations/en.yml'  
import EventHandler from 'bootstrap/js/src/dom/event-handler'

// if pathname includes /en/ set language to english
let privacyPage = '/impressum-datenschutz/'
if (window.location.pathname.includes('/en/')) {
    privacyPage = '/en/imprint/'
}

en.privacyPolicyUrl = window.privacyLink || privacyPage
console.log(window.privacyLink)
const hostParts = window.location.hostname.split('.').reverse()
// Klaro config
const config = {
    acceptAll: true,
    cookieExpiresAfterDays: 365,
    cookieDomain: `.${hostParts[1]}.${hostParts[0]}`,
    cookieName: 'consent',
    default: false,
    elementID: 'klaro',
    embedded: false,
    groupByPurpose: true,
    hideDeclineAll: false,
    hideLearnMore: false,
    htmlTexts: true,
    mustConsent: false,
    noAutoLoad: false,
    noticeAsModal: false,
    services: [
        {
            name: 'system',
            purposes: ['necessary'],
            default: true,
            required: true
        },
        {
            name: 'googleMaps',
            purposes: ['services'],
            contextualConsentOnly: true
        },
    ],
    storageMethod: 'cookie',
    styling: {
        theme: 'light',
    },
    translations: {
        zz: en,
        de
    },
    version: 1
};


document.querySelectorAll('a[href$="#manage-cookies"]').forEach((item) => {
    EventHandler.on(item, 'click', (e: MouseEvent) => {
        e.preventDefault();
        klaro.show()
    })
})

// Init Klaro
window.klaro = Klaro
window.klaroConfig = config
Klaro.setup(config)

